import { Action, createReducer, on } from '@ngrx/store';
import {
  loadGoogleMapsApi,
  loadGoogleMapsApiFailure,
  loadGoogleMapsApiSuccess,
} from './actions';
import { State, initialState } from './state';

export const googleMapsApiFeatureKey = 'google-maps-api';

const googleMapsApiReducer = createReducer(
  initialState,

  on(loadGoogleMapsApi, (state) => ({
    ...state,
    googleMapsApiLoading: true,
    googleMapsApiLoaded: false,
  })),
  on(loadGoogleMapsApiSuccess, (state) => ({
    ...state,
    googleMapsApiLoading: false,
    googleMapsApiLoaded: true,
  })),
  on(loadGoogleMapsApiFailure, (state, { error, message }) => ({
    ...state,
    googleMapsApiLoading: false,
    googleMapsApiLoaded: false,
    googleMapsApiLoadedFailure: { error, message },
  })),
);

export const reducer = (state: State | undefined, action: Action) =>
  googleMapsApiReducer(state, action);
